import { IconType } from 'react-icons';
import { FaHome, FaChartPie, FaUser, FaTags, FaCreditCard, FaFileInvoiceDollar, FaExchangeAlt } from 'react-icons/fa';
import { MdAccountBalance } from 'react-icons/md';

export interface NavItem {
  label: string;
  icon: IconType;
  path: string;
  // Telas filhas que acendem o mesmo item (extrato é parte de Bancos)
  tambem?: string[];
}

// Os do dia a dia ficam sempre visíveis na barra do celular; o resto vai
// para o "Mais"
export const navPrincipais: NavItem[] = [
  { label: 'Início', icon: FaHome, path: '/dashboard' },
  { label: 'Lançamentos', icon: FaExchangeAlt, path: '/lancamentos' },
  { label: 'Planejamento', icon: FaChartPie, path: '/planejamento' },
  { label: 'Contas', icon: FaFileInvoiceDollar, path: '/contas' },
];

export const navSecundarios: NavItem[] = [
  { label: 'Bancos', icon: MdAccountBalance, path: '/bancos', tambem: ['/extrato-banco'] },
  { label: 'Cartões', icon: FaCreditCard, path: '/cartoes', tambem: ['/faturas-cartao'] },
  { label: 'Categorias', icon: FaTags, path: '/categorias' },
  { label: 'Perfil', icon: FaUser, path: '/profile' },
];

export const ativo = (item: NavItem, pathname: string) =>
  pathname === item.path || !!item.tambem?.includes(pathname);
